import React from "react";
import { useFormContext } from "react-hook-form";
import { ClientConfiguration } from "../../models/ClientConfiguration/ClientConfiguration";
import { DriveMapping } from "../../models/ClientConfiguration/DriveMapping";
import {DocTypeMapping} from "../../models/ClientConfiguration/DocTypeMapping";
import {ImplementationType} from "../../models/OrganizationConfiguration/ImplementationType";
import DriveMappingsControls from "./DriveMappingsControl";
import DocTypeMappingsControl from "./DocTypeMappingsControl";

interface MappingsSettingsSectionProps {
  implementationType: ImplementationType;
  disabled?: boolean;
}

const MappingsSettingsSection: React.FC<MappingsSettingsSectionProps> = ({
  implementationType,
  disabled = false,
}) => {
  const form = useFormContext<ClientConfiguration>();

  const driveMappings = form.watch("driveMappings");
  const docTypeMappings = form.watch("docTypeMappings");

  const handleDriveMappingsChange = (mappings: DriveMapping[]) => {
    form.setValue("driveMappings", mappings);
  };

  const handleDocTypeMappingsChange = (mappings: DocTypeMapping[]) => {
    form.setValue("docTypeMappings", mappings);
  };

  return (
    <div className="grid grid-cols-12 h-full w-full">
      <div className="col-span-12 min-w-full">
        <DriveMappingsControls
          driveMappings={driveMappings || []}
          onChange={handleDriveMappingsChange}
          disabled={disabled}
        />
      </div>
      {implementationType === ImplementationType.TrialWorks ? (
        <div className="col-span-12">
          <DocTypeMappingsControl
            docTypeMappings={docTypeMappings || []}
            onChange={handleDocTypeMappingsChange}
            disabled={disabled}
          />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default MappingsSettingsSection;
